import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import endPoint from "../EndPoint/endpoint";

export const LoginApi = createAsyncThunk(
  "loginData/loginApi",
  async (email, thunkAPI) => {
  
    try {
      const response = await axios.post(endPoint.LOGIN, {
        email: email?.email,
        password: email?.password,
      });
      localStorage.setItem("authToken", response?.data?.token);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

const LoginSlice = createSlice({
  name: "ProfileData",
  initialState: {
    ProfileData: [],
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(LoginApi.fulfilled, (state, action) => {
        state.ProfileData = action.payload;
      })
      .addCase(LoginApi.rejected, (state, action) => {
        state.error = action.payload;
      });
  },
});

export default LoginSlice.reducer;
